import type { ComponentProps, ReactNode } from "react"

import { SectionHeader, SeeAllButton } from "@/components/marketplace/layout/section-header"
import { withPalette, type Palette } from "@/components/marketplace/palette"
import { Stack } from "@/components/ui"

interface SectionProps {
  title: ReactNode
  accent?: ReactNode
  eyebrow?: ReactNode
  action?: ReactNode
  palette?: Palette
  headerSize?: ComponentProps<typeof SectionHeader>["size"]
  headerTone?: ComponentProps<typeof SectionHeader>["tone"]
  numeral?: string
  money?: string
  className?: string
  children: ReactNode
}

export const Section = ({ title, accent, eyebrow, action = <SeeAllButton />, palette, headerSize, headerTone, numeral, money, className, children }: SectionProps) => (
  <Stack as="section" gap="500" className={withPalette(palette, `@3xl:gap-750 ${className ?? ""}`)}>
    <SectionHeader title={title} accent={accent} eyebrow={eyebrow} action={action} size={headerSize} tone={headerTone} numeral={numeral} money={money} className="px-gut" />
    {children}
  </Stack>
)
